import { render, staticRenderFns } from "./SimuladorPassoResultado.vue?vue&type=template&id=3e252b4a&"
import script from "./SimuladorPassoResultado.vue?vue&type=script&lang=js&"
export * from "./SimuladorPassoResultado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports